/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundPictureOrderGoodsInfoVo
 */
export interface InboundPictureOrderGoodsInfoVo {
    /**
     * 商品id
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    goodsId?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    orderCode?: string;
    /**
     * 接收人
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    receiver?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    goodsCode?: number;
    /**
     * 商品图片
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    goodsImg?: string;
    /**
     * 颜色颜色
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    size?: string;
    /**
     * 数量
     * @type {number}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    quantity?: number;
    /**
     * 商品状态
     * @type {string}
     * @memberof InboundPictureOrderGoodsInfoVo
     */
    goodsStatusName?: string;
}

/**
 * Check if a given object implements the InboundPictureOrderGoodsInfoVo interface.
 */
export function instanceOfInboundPictureOrderGoodsInfoVo(value: object): value is InboundPictureOrderGoodsInfoVo {
    return true;
}

export function InboundPictureOrderGoodsInfoVoFromJSON(json: any): InboundPictureOrderGoodsInfoVo {
    return InboundPictureOrderGoodsInfoVoFromJSONTyped(json, false);
}

export function InboundPictureOrderGoodsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundPictureOrderGoodsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsImg': json['goodsImg'] == null ? undefined : json['goodsImg'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
    };
}

export function InboundPictureOrderGoodsInfoVoToJSON(json: any): InboundPictureOrderGoodsInfoVo {
    return InboundPictureOrderGoodsInfoVoToJSONTyped(json, false);
}

export function InboundPictureOrderGoodsInfoVoToJSONTyped(value?: InboundPictureOrderGoodsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'orderCode': value['orderCode'],
        'receiver': value['receiver'],
        'goodsCode': value['goodsCode'],
        'goodsImg': value['goodsImg'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'goodsStatusName': value['goodsStatusName'],
    };
}

